import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import styles from './_ownEveryMileLanding.css'
import Svg from 'components/util/Svg'
import messages from './messages'

function OwnEveryMile (props) {
  const {
    signUp,
    logIn,
    site,
  } = props

  const {
    appStoreLink,
    shortName,
    slug,
  } = site
  const caption = messages.caption[slug] || messages.caption.default
  const title = messages.title[slug] || messages.title.default

  const inlineStyles = {
    color: 'white',
    align: 'right',
  }

  const flavorClass = styles[slug] || ''

  return (
    <div className={styles.ownEveryMileWrapper}>
      <div className={`${styles.ownEveryMile} ${flavorClass}`}>
        <Title {...inlineStyles} >
          { title ? <FormattedMessage {...title} /> : null }
        </Title>
        <Caption {...inlineStyles}>
          { caption ? <FormattedMessage {...caption} /> : null }
        </Caption>
        <div className={styles.callToAction}>
          <div className={styles.signUp}>
            <Link className={styles.signUpButton} to='/auth/signup' onClick={() => signUp('sign_up_home')}>
              <FormattedMessage id='site.nav.signup' defaultMessage='Sign Up' />
            </Link>
          </div>
          <div className={styles.logIn}>
            <p className={styles.logInQuestion}>
              <FormattedMessage id='landingPage.ownEveryMile.login.question' defaultMessage='Already a member?' />
            </p>
            <Link className={styles.logInButton} to='/auth/login' onClick={() => logIn('log_in_home')}>
              <FormattedMessage id='site.nav.login' defaultMessage='Log in' />
            </Link>
          </div>
          <div className={styles.appStoreContainer}>
            <a className={styles.appStoreLink} target='_blank' rel='noopener noreferrer' href={appStoreLink}>
              <Svg className={styles.appStoreIcon} name='apple-app-store' />
            </a>
            <a className={styles.appStoreLink} target='_blank' rel='noopener noreferrer' href={`https://play.google.com/store/apps/details?id=com.${shortName}.android2&hl=en`}>
              <Svg className={styles.appStoreIcon} name='google-play-store' />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

OwnEveryMile.propTypes = {
  site: PropTypes.object,
  logIn: PropTypes.func,
  signUp: PropTypes.func,
}

export default OwnEveryMile
